<footer class="footer">
  <div class="footer-main">
    <div class="container">
      <div class="footer-grid">
        <!-- Über uns -->
        <div class="footer-column">
          <div class="footer-logo">
            <img fill [ngSrc]="imageService.getOptimizedImageUrl(logoImage, { width: 200 })" [alt]="logoAltText" class="logo-image">
          </div>
          <p class="footer-description">
            Dein Wegweiser für kulinarische Kräuter und Heilpflanzen. <br> <br>
            Wir teilen Wissen über den Anbau, die Verwendung und die Heilkraft von Küchenkräutern für authentische Aromen in deiner Küche.
          </p>
          <!-- <div class="footer-social">
            <a href="https://facebook.com/krautersaat" aria-label="Besuche uns auf Facebook">
              <i class="fab fa-facebook-f"></i>
            </a>
            <a href="https://instagram.com/krautersaat" aria-label="Folge uns auf Instagram">
              <i class="fab fa-instagram"></i>
            </a>
            <a href="https://pinterest.com/krautersaat" aria-label="Entdecke unsere Pins auf Pinterest">
              <i class="fab fa-pinterest-p"></i>
            </a>
          </div> -->
        </div>
        
        <!-- Beliebte Kräuter -->
        <div class="footer-column">
          <h3 class="footer-heading">Beliebte Kräuter</h3>
          <ul class="footer-links">
            <li *ngFor="let link of popularInfoLinks"><a [routerLink]="link.path">{{ link.label }}</a></li>
          </ul>
        </div>
                
        <!-- Weitere Links -->
        <div class="footer-column">
          <h3 class="footer-heading">Weiteres</h3>
          <ul class="footer-links">
            <!-- <li><a routerLink="/rezepte">Rezepte</a></li> -->
            <li><a [routerLink]="blogPath">Blog</a></li>
            <li><a [routerLink]="seasonCalendarPath">Kräuter-Saisonkalender</a></li>
            <li><a [routerLink]="lexiconOverviewPath">Kräuter-Lexikon</a></li>
            <!-- <li><a routerLink="/newsletter">Newsletter</a></li> -->
            <li><a [routerLink]="aboutPath">Über uns</a></li>
            <!-- <li><a routerLink="/kontakt">Kontakt</a></li> -->
          </ul>
        </div>
      </div>
      
      <!-- Newsletter Mini-Form im Footer -->
      <!-- <div class="footer-newsletter">
        <h3 class="footer-heading">Kräuter-Newsletter abonnieren</h3>
        <p>Erhalte saisonale Tipps, Rezepte und Anbauratgeber direkt in dein Postfach:</p>
        <form class="footer-newsletter-form" (ngSubmit)="subscribeToNewsletter(footerEmail)">
          <input type="email" [(ngModel)]="footerEmail" name="footerEmail" placeholder="Deine E-Mail-Adresse" required>
          <button type="submit">Anmelden</button>
        </form>
      </div> -->
    </div>
  </div>
  
  
  <!-- Rechtliches und Sitemap -->
  <div class="footer-bottom">
    <div class="container">
      <div class="footer-legal">
        <p>&copy; {{ currentYear }} {{ brandName }}. Alle Rechte vorbehalten.</p>
        <div class="legal-links">
          <a [routerLink]="impressumPath">Impressum</a>
          <a [routerLink]="datenschutzPath">Datenschutz</a>
          <a (click)="showCookieBanner()" routerLink="/">Cookie Einstellungen</a>
        </div>
      </div>
    </div>
  </div>
</footer>


